module.exports = __webpack_public_path__ + "img/lessonLearn_img.fd4b744f.svg";